import { MessageCircle, Phone, Mail, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE_TEL, PHONE_DISPLAY, EMAIL, waLink } from "@/lib/contact";

export default function Footer() {
  return (
    <footer className="bg-[#111111] text-[#F5F0E8] pt-20 md:pt-28 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="flex items-center gap-3">
                <span className="h-px w-10 bg-[#8DA37F]" />
                <span className="text-xs tracking-[0.25em] uppercase font-medium text-[#8DA37F]">
                  Start today
                </span>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-light text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight mt-6">
                Your body is ready.
                <br />
                <span className="italic text-[#8DA37F]">Are you?</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 flex flex-wrap gap-4">
                <a
                  href={waLink("Hi Physiora, I'd like to get started.")}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-btn"
                  className="inline-flex items-center gap-3 bg-[#8DA37F] text-[#111111] text-xs tracking-[0.15em] uppercase font-medium px-8 py-4 rounded-full hover:bg-[#F5F0E8] hover:-translate-y-0.5 transition-all duration-300"
                >
                  <MessageCircle className="h-4 w-4" />
                  WhatsApp us
                </a>
                <a
                  href={PHONE_TEL}
                  data-testid="footer-call-btn"
                  className="inline-flex items-center gap-3 text-xs tracking-[0.15em] uppercase font-medium px-8 py-4 rounded-full border border-[#F5F0E8]/30 text-[#F5F0E8] hover:border-[#F5F0E8] hover:-translate-y-0.5 transition-all duration-300"
                >
                  <Phone className="h-4 w-4" />
                  {PHONE_DISPLAY}
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <div className="space-y-5">
                <a
                  href={PHONE_TEL}
                  data-testid="footer-phone-link"
                  className="group flex items-center justify-between border-b border-[#F5F0E8]/15 pb-5"
                >
                  <span className="text-xs tracking-[0.2em] uppercase text-[#F5F0E8]/50">Phone</span>
                  <span className="flex items-center gap-2 text-lg group-hover:text-[#8DA37F] transition-colors duration-300">
                    {PHONE_DISPLAY}
                    <ArrowUpRight className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </span>
                </a>
                <a
                  href={`mailto:${EMAIL}`}
                  data-testid="footer-email-link"
                  className="group flex items-center justify-between border-b border-[#F5F0E8]/15 pb-5"
                >
                  <span className="text-xs tracking-[0.2em] uppercase text-[#F5F0E8]/50">Email</span>
                  <span className="flex items-center gap-2 text-lg group-hover:text-[#8DA37F] transition-colors duration-300">
                    {EMAIL}
                    <Mail className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </span>
                </a>
                <a
                  href={waLink("Hi Physiora!")}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="group flex items-center justify-between border-b border-[#F5F0E8]/15 pb-5"
                >
                  <span className="text-xs tracking-[0.2em] uppercase text-[#F5F0E8]/50">WhatsApp</span>
                  <span className="flex items-center gap-2 text-lg group-hover:text-[#8DA37F] transition-colors duration-300">
                    Chat with us
                    <MessageCircle className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </span>
                </a>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <p className="font-display font-light text-[18vw] leading-none tracking-tight text-[#F5F0E8]/10 select-none text-center mt-20 md:mt-28 -mb-4 md:-mb-8">
            PHYSIORA
          </p>
        </Reveal>

        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-[#F5F0E8]/10 pt-8 mt-4">
          <div className="flex items-center gap-3">
            <img src="/logo-icon.png" alt="Physiora mark" className="h-7 w-7 object-contain opacity-80" />
            <span className="text-xs tracking-[0.2em] uppercase text-[#F5F0E8]/50">
              Move Heal Live — ESTD 2026
            </span>
          </div>
          <p className="text-xs tracking-[0.2em] uppercase text-[#F5F0E8]/40">
            Online physiotherapy &amp; strength and conditioning
          </p>
        </div>
      </div>
    </footer>
  );
}
